<template>
  <div class="d-flex justify-content-between">
    <side-block label="A" :caption="$t('side')" :invisible="invisible.includes('A')"/>
    <side-block label="B" :caption="$t('side')" :invisible="invisible.includes('B')"/> 
  </div>
</template>

<script>
import SideBlock from './SideBlock'

export default {
  props: {
    invisible: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SideBlock
  }
}
</script>